import React from 'react';
import Header2 from './../Common/Header2';
import Header4 from './../Common/Header4';
import SEO from './../Common/SEO';
import Footer from './../Common/Footer';
import Banner from './../Elements/Banner';
import About2 from './../Elements/About2';
import About3 from '../Elements/About3';
import About4 from '../Elements/About4';
import WhatWeDo6 from './../Elements/WhatWeDo6';
import Achievements1 from './../Elements/Achievements1';
import Team1 from './../Elements/Team1';

import Testimonials2 from './../Elements/Testimonials2';
import About6 from '../Elements/About6';
import Footer2 from '../Common/Footer2';

var bnrimg = require('./../../images/banner/5.jpg');
var founderImg = require('./../../images/our-team5/r2.jpg');
var coFounderImg = require('./../../images/our-team5/p1.jpg');

class About1 extends React.Component {
    componentDidMount() {
        function loadScript(src) {

            return new Promise(function (resolve, reject) {
                var script = document.createElement('script');
                script.src = src;
                script.addEventListener('load', function () {
                    resolve();
                });
                script.addEventListener('error', function (e) {
                    reject(e);
                });
                document.body.appendChild(script);
                document.body.removeChild(script);
            })
        };

        loadScript('./assets/js/custom.js');

    };
    render() {
        return (
            <>
                <SEO
                  titleExact
                  title="About Infrio India – Visionary Architecture and Design"
                  description="Learn about Infrio India's mission to create functional, aesthetic and sustainable spaces. We combine innovative design thinking with expert execution for architecture, interior design, planning & build services across India."
                  keywords="Infrio India, about Infrio India, architectural design company India, design philosophy, interior design experts Indore, sustainable architecture firm, planning & build experts, design studio India"
                  canonicalPath="/about-us"
                />
                <Header2 />
                <div className="page-content">
                    <Banner title="About Infrio" pagename="About 1" description="Where Design Meets Execution We bring ideas to life through smart planning, elegant design, and quality construction." bgimage={bnrimg}/>
                    <About2 />
                   
                  <About3 bgcolor="bg-gray" showVideoButton={false} />
                    <About4 bgcolor="bg-gray" />         
         {/* <WhatWeDo6 /> */}
                    {/* <Achievements1 /> */}
                    <div className="section-full bg-white p-b50">
                        <div className="container">
                            <div className="section-head">
                                <div className="sx-separator-outer separator-center">
                                    <div className="sx-separator bg-white bg-moving bg-repeat-x" style={{ backgroundImage: 'url(' + require('./../../images/background/cross-line2.png') + ')' }}>
                                        <h3 className="sep-line-one">Leadership &amp; Team</h3>
                                    </div>
                                </div>
                            </div>
                            <div className="row justify-content-center">
                                <div className="col-lg-5 col-md-6 col-sm-12 m-b30">
                                    <div className="our-team-2 shadow-sm h-100">
                                        <div className="profile-image" style={{ width: '100%', height: '320px', overflow: 'hidden', borderRadius: '12px 12px 0 0' }}>
                                            <img src={founderImg} alt="Founder" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                        </div>
                                        <div className="figcaption text-black p-a25">
                                            <h4 className="m-t0">Rajesh Malav</h4>
                                            <span className="m-b15 d-block text-primary text-uppercase" style={{ letterSpacing: '1px', fontWeight: 600 }}>Founder &amp; Director</span>
                                            <p className="text-muted" style={{ lineHeight: 1.7 }}>
                                                With over 15 years of experience in architecture and turnkey construction, Rajesh leads Infrio’s vision of crafting functional, future-ready spaces.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-5 col-md-6 col-sm-12 m-b30">
                                    <div className="our-team-2 shadow-sm h-100">
                                        <div className="profile-image" style={{ width: '100%', height: '320px', overflow: 'hidden', borderRadius: '12px 12px 0 0' }}>
                                            <img src={coFounderImg} alt="Co-Founder" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                        </div>
                                        <div className="figcaption text-black p-a25">
                                            <h4 className="m-t0">Pooja Malav</h4>
                                            <span className="m-b15 d-block text-primary text-uppercase" style={{ letterSpacing: '1px', fontWeight: 600 }}>Head of Architect & Interior Designing</span>
                                            <p className="text-muted" style={{ lineHeight: 1.7 }}>
                                            Pooja Malav, a Civil Engineering graduate from GSITS Indore, drives the design language at Infrio, blending aesthetics with practicality to deliver immersive interior experiences for every client.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <Team1 embedded />
                        </div>
                    </div>
                    <Testimonials2 separatoralignment="separator-center" />
                </div>

                <Footer2 />
            </>
        );
    };
};

export default About1;
